import {
  Middleware, PayloadAction, isRejectedWithValue,
} from '@reduxjs/toolkit';
import {
  ERROR,
  ErrorKeyCodeEnum,
  UNAUTHORIZED_ERROR,
} from 'infra/error/errors';
import { createAlertNotification } from 'infra/notification';
import { AlertNotificationType, setNotificationAction } from 'state/slices/notification';
import { cleanSessionAction } from 'state/slices/session';

const isMappedError = (
  errorCode: string,
): errorCode is ErrorKeyCodeEnum => Object.keys(ERROR).includes(errorCode);

// TODO: create test
export const errorHandlerMiddleware: Middleware = (api) => (next) => (action: PayloadAction) => {
  if (isRejectedWithValue(action)) {
    const code = action.error.code || ErrorKeyCodeEnum.SILENCED_INTERNAL_ERROR;
    // const appError = ERROR[action.error?.code] || ERROR[SILENCED_INTERNAL_ERROR.keyCode];
    const appError = isMappedError(code)
      ? ERROR[code]
      : ERROR[ErrorKeyCodeEnum.SILENCED_INTERNAL_ERROR];
    if (appError.keyCode === UNAUTHORIZED_ERROR.keyCode) {
      api.dispatch(cleanSessionAction());
    }

    if (appError.shouldNotify) {
      const alertMessage = appError.message || action.error.message || 'Erro genérico';
      const alert = createAlertNotification(alertMessage, AlertNotificationType.Error);
      api.dispatch(setNotificationAction(alert));
    }
  }
  next(action);
};
